export default "__VITE_ASSET__I4V_W2pV__"